import React from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

interface FaqProps {
  onBack: () => void;
}

export default function Faq({ onBack }: FaqProps) {
  const { t } = useTranslation();

  const sections = [
    {
      titleKey: "faq.sectionElo",
      items: [
        { q: "faq.q_eloCalc", a: "faq.a_eloCalc" },
        { q: "faq.q_grayed", a: "faq.a_grayed" },
      ],
    },
    {
      titleKey: "faq.sectionMatches",
      items: [
        { q: "faq.q_declareMatch", a: "faq.a_declareMatch" },
        { q: "faq.q_validateMatch", a: "faq.a_validateMatch" },
        { q: "faq.q_cancelMatch", a: "faq.a_cancelMatch" },
      ],
    },
    {
      titleKey: "faq.sectionAmericano",
      items: [
        { q: "faq.q_americanoHow", a: "faq.a_americanoHow" },
        { q: "faq.q_americanoElo", a: "faq.a_americanoElo" },
      ],
    },
    {
      titleKey: "faq.sectionAccount",
      items: [
        { q: "faq.q_addGuest", a: "faq.a_addGuest" },
        { q: "faq.q_changeProfile", a: "faq.a_changeProfile" },
        { q: "faq.q_contact", a: "faq.a_contact" },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-background border-b px-4 py-3 flex items-center gap-3 safe-area-top">
        <Button variant="ghost" size="sm" onClick={onBack} className="p-0 h-auto">
          <ChevronLeft className="w-5 h-5" />
        </Button>
        <h1 className="text-lg font-semibold">{t("faq.title")}</h1>
      </div>

      <main className="px-4 py-4 space-y-6 max-w-2xl mx-auto pb-8">
        {sections.map((section) => (
          <div key={section.titleKey}>
            <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide mb-2">
              {t(section.titleKey)}
            </h2>
            <Accordion type="single" collapsible className="border rounded-lg overflow-hidden">
              {section.items.map((item, idx) => (
                <AccordionItem key={item.q} value={item.q} className={idx === 0 ? "border-t-0" : ""}>
                  <AccordionTrigger className="px-4 text-sm font-medium text-left">
                    {t(item.q)}
                  </AccordionTrigger>
                  <AccordionContent className="px-4 text-sm text-muted-foreground leading-relaxed">
                    {t(item.a)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}
      </main>
    </div>
  );
}
